<template>
  <div>
    <div v-if="!removeTailwindAlert" class="z-2 border-b border-gray-500 bg-gray-800 rounded-t text-sm relative z-30 w-full p-2 text-white">
      Visit <a class="text-blue-300 hover:underline" href="https://tailwindcss.com/docs/typography-plugin" target="_blank">Tailwind typography</a> for advanced use.
    </div>
    <textarea
      @scroll="scroll"
      ref='textarea'
      v-model="text"
      placeholder="Write raw HTML here..."

      class="z-10 caret-[#e2e8f0] left-0 top-0 text-sm h-full w-full p-2 border-0 box-border rounded resize-none whitespace-pre-wrap break-all overflow-auto overflow-x-hidden absolute outline-none bg-[#1e293b] prism-language-markup "
      :class="!removeTailwindAlert && 'pt-12'"
      contenteditable="true"
      :style="{height}"
    ></textarea>
    <div
      class="z-20 pointer-events-none text-sm !bg-transparent  left-0 top-0 h-full w-full p-2 border-0 box-border rounded resize-none whitespace-pre-wrap break-all overflow-auto overflow-x-hidden absolute outline-none bg-[#1e293b] prism-language-markup text-white"
      :class="!removeTailwindAlert && 'pt-12'"

      ref="preview"
      :style="{height}"
    ><span v-html="preview"></span></div>
  </div>
</template>

<script>

export default {
  props: ['id', 'title', 'role', 'config', 'content', 'value', 'removeTailwindAlert'],
  mounted() {
    this.updatePreview()
    this.$nextTick(() => {
      this.calcHeight()
      this.$refs.textarea.focus()
    })

    window.addEventListener("resize", this.calcHeight, {passive: true})
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcHeight)
  },
  data() {
    return {
      text: html_beautify((this.content && this.content.rich_text) || this.value || ""),
      preview: "",
      height: null,
    }
  },
  methods: {
    reset() {
      this.text = html_beautify(this.value || "")
    },
    calcHeight() {
      this.$refs.textarea.height = 'auto'
      requestAnimationFrame(() => {
        this.height = this.$refs.textarea.getBoundingClientRect().height + 'px'
      })
    },
    updatePreview() {
      this.preview = Prism.highlight(this.text, Prism.languages.html, 'html')
      this.$emit('save', this.text.replace(/'/g, "&#145;"))
    },
    scroll() {
      this.$refs.preview.scrollTop = this.$refs.textarea.scrollTop
    },
  },
  watch: {
    value() {
      this.reset()
    },
    text() {
      this.updatePreview()
    },
  },
}

</script>

<style scoped>

.prism-language-markup {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

</style>
